import './App.css';

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/navbar/Navbar';
import { Accueil } from './pages/Accueil/Accueil';
import { Mariage } from './pages/Mariage/Mariage';
import { Tourisme } from './pages/Tourisme/Tourisme';
import { FAQ } from './pages/Faq/Faq';
import { Pratique } from './pages/Pratique/Pratique';
import { ScrollToAnchor } from './components/ScrollAnchor/ScrollAnchor';

const App = () => {
   return (
      <Router>
         <ScrollToAnchor />
         <Navbar />
         <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/mariage" element={<Mariage />} />
            <Route path="/pratique" element={<Pratique />} />
            <Route path="/tourisme" element={<Tourisme />} />
            <Route path="/faq" element={<FAQ />} />
         </Routes>
      </Router>
   );
};

export default App;
